import { useEffect, useLayoutEffect, useRef } from "react";

/**
 *  Call this hook in any component and body scrolling will be locked until that component unmounts.
 */
export default function useLockBodyScroll(on: boolean): void {
  let originalStyle: string | undefined = useRef().current;
  let originalStyleHtml: string | undefined = useRef().current;

  useLayoutEffect((): (() => void) => {
    // Get original body overflow
    originalStyle = window.getComputedStyle(document.body).overflow;
    originalStyleHtml = window.getComputedStyle(document.documentElement).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = on ? "hidden" : originalStyle;
    document.documentElement.style.overflow = on ? "hidden" : originalStyleHtml;
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle || "unset";
      document.documentElement.style.overflow = originalStyleHtml || "unset";
    };
  }, []); // Empty array ensures effect is only run on mount and unmount

  useEffect(() => {
    document.body.style.overflow = on ? "hidden" : originalStyle || "unset";
    document.documentElement.style.overflow = on ? "hidden" : originalStyleHtml || "unset";
  }, [on]);
}
